(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vantage-notify-me"] && !Shopify.designMode) return;
  try {
    document.addEventListener('vpdp:variant', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-vnotify]').forEach(function (box) {
      box.hidden = !!variant.available;
      if (variant.available) return;

      var set = function (selector, value) {
        var field = box.querySelector(selector);
        if (field) field.value = value == null ? '' : value;
      };
      set('[data-vnotify-variant]', variant.title);
      set('[data-vnotify-sku]', variant.sku);

      var blurb = box.querySelector('[data-vnotify-blurb]');
      if (blurb && blurb.dataset.template) {
        blurb.textContent = blurb.dataset.template.replace('__VARIANT__', variant.title);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
